import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteOperacaoBatelada,
  findOperacaoBatelada,
  recordFiltering,
} from '~/store/modules/operacaobatelada/actions';

import FormBatelada from './form';

function OperacaoBateladaList() {
  const redux = useSelector((state) => state.operacaobatelada);
  const { internounidatausuario } = useSelector((state) => state.user.configs);
  const tipoopt = [
    { label: '0', value: t('s.operacao.batelada.tipo.calculado') },
    { label: '1', value: t('s.operacao.batelada.tipo.medido') },
  ];
  const header = useMemo(
    () => [
      {
        id: 'nomeabreviadoposto',
        label: t('s.operacao.batelada.nomeabreviadoposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idtanquevirtual',
        label: t('s.operacao.batelada.idtanquevirtual'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigotanquefisico',
        label: t('s.operacao.batelada.codigotanquefisico'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'datahorainiciobatelada',
        label: t('s.operacao.batelada.datahorainicio'),
        formatted: (date) => formatISO({ date }),
      },
      {
        id: 'densidadeobsbatelada',
        label: t('s.operacao.batelada.densidadeobs'),
        align: 'right',
        formatted: (value) => number(value, 4),
      },
      {
        id: 'temperaturaobsbatelada',
        label: t('s.operacao.batelada.temperaturaobs'),
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'densidade20batelada',
        label: t('s.operacao.batelada.densidade20'),
        align: 'right',
        formatted: (value) => number(value, 4),
      },
    ],
    []
  );

  const actions = useMemo(() => [], [internounidatausuario]);

  const fieldlist = [
    'nomeabreviadoposto',
    'idtanquevirtual',
    'codigotanquefisico',
    'datahorainiciobatelada',
    'densidadeobsbatelada',
    'temperaturaobsbatelada',
    'densidade20batelada',
  ];

  const substituirHeader = {
    nomeabreviadoposto: t('s.operacao.batelada.nomeabreviadoposto'),
    idtanquevirtual: t('s.operacao.batelada.idtanquevirtual'),
    codigotanquefisico: t('s.operacao.batelada.codigotanquefisico'),
    datahorainiciobatelada: t('s.operacao.batelada.datahorainicio'),
    densidadeobsbatelada: t('s.operacao.batelada.densidadeobs'),
    temperaturaobsbatelada: t('s.operacao.batelada.temperaturaobs'),
    densidade20batelada: t('s.operacao.batelada.densidade20'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findOperacaoBatelada}
      delete={false}
      remove={deleteOperacaoBatelada}
      form={FormBatelada}
      actions={actions}
      detach="idbatelada"
      keys={['idbatelada']}
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'bateladas',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Bateladas',
          ignorarFormatacao: {
            densidadeobsbatelada: true,
            densidade20batelada: true,
          },
        })
      }
    />
  );
}

export default OperacaoBateladaList;
